import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { StoriesBar } from "@/components/StoriesBar";
import { Hero } from "@/components/Hero";
import { RecentProjects } from "@/components/RecentProjects";
import { TrustBadges } from "@/components/TrustBadges";
import { CallToActionSection } from "@/components/CallToActionSection";
import { Services } from "@/components/Services";
import { Testimonials } from "@/components/Testimonials";
import { Coupons } from "@/components/Coupons";
import { ProjectGallery } from "@/components/ProjectGallery";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { FAQ } from "@/components/FAQ";
import { usePhoneNumber } from "@/hooks/usePhoneNumber";
import { usePhoneBar } from "@/contexts/PhoneBarContext";

const CityLanding = () => {
  const { cityName } = useParams<{ cityName: string }>();
  const { setPhoneNumber } = usePhoneBar();
  
  // Debug: Log the raw cityName parameter
  console.log('CityLanding - Raw cityName from URL:', cityName);
  
  // Format city name: convert hyphens to spaces and capitalize each word
  const formatCityName = (city: string) => {
    return city
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const formattedCity = cityName ? formatCityName(cityName) : "Long Island";
  console.log('CityLanding - Formatted city:', formattedCity);
  const phoneInfo = usePhoneNumber(formattedCity);

  useEffect(() => {
    setPhoneNumber(phoneInfo.tel);
  }, [phoneInfo.tel, setPhoneNumber]);

  return (
    <main className="min-h-screen">
      <SEOHead 
        cityName={formattedCity}
        canonical={`https://quote.safewayroofingandchimney.com/city/${cityName}`}
      />
      <Header />
      <StoriesBar />
      <Hero cityName={formattedCity} />
      <RecentProjects cityName={formattedCity} />
      <TrustBadges cityName={formattedCity} />
      <CallToActionSection />
      <Services cityName={formattedCity} />
      <Testimonials />
      <FAQ cityName={formattedCity} />
      <Coupons />
      <ProjectGallery />
      <Footer />
    </main>
  );
};

export default CityLanding;